<template>
    <div>
        <label>
            {{ title }}
            <span v-if="required" class="text-danger">*</span>
        </label>
        <div class="input-group">
            <div class="input-group-text">+1</div>
            <input
                :type="type"
                :name="name"
                class="form-control"
                :placeholder="title"
                v-model="phoneNumber"
                @keyup="onlyNumberKey"
                :class="{
                    'is-invalid': error,
                }"
            />
            <div
                v-if="error"
                class="invalid-feedback"
            >
                {{ error }}
            </div>
        </div>
    </div>    
</template>


<script>
    export default {
        props: {
            title: String,
            name: String,
            model: String,
            error: String,
            type: String,
            required: Boolean
        },
        data() {
            return {
                phoneNumber: this.model,
            }
        },
        methods: {
            onlyNumberKey() {
                if (this.phoneNumber != null) {
                    let phoneNum = this.phoneNumber.replace(
                        /[^0-9]/g,
                        ""
                    );

                    const part1 =
                        phoneNum.length > 2
                            ? `(${phoneNum.substring(0, 3)})`
                            : phoneNum;
                    const part2 =
                        phoneNum.length > 3 ? ` ${phoneNum.substring(3, 6)}` : "";
                    const part3 =
                        phoneNum.length > 6 ? `-${phoneNum.substring(6, 10)}` : "";

                    this.phoneNumber = `${part1}${part2}${part3}`;

                    this.$emit('phoneFormatted', this.phoneNumber);
                }
            },
        }
    }
</script>

